import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { InvestmentService } from "../investment.service";
import { InvestmentModel } from "../investment.model";
import { InvestmentListComponent } from './investment-list.component';

@Component({
    selector: 'convfact-investments-dialog',
    templateUrl: './tableDialog.component.html',
    styleUrls: ['./investment.component.css'],
    standalone: false
})

export class TableDialogComponent implements OnInit {
  ready: boolean = false;
  activityUid: string = this.data.activityUid;
  investmentUid: string = this.data.investmentUid;
  investment: InvestmentModel;
  enero: string = "0 ";
  monthDateStartWorking: number;
  cuota: number;

  constructor(
    public dialogRef: MatDialogRef<InvestmentListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
    private investmentService: InvestmentService,
  ) { }

  closeDialog() {
    this.dialogRef.close();
  }

  ngOnInit() {
    this.investmentService.loadData(this.investmentUid).then(investment => {
      this.investment = investment;
      const date = new Date(investment.dateStartWorking);
      this.monthDateStartWorking = date.getMonth() + 1;
      const percent = (investment.totalWithoutTax * investment.maximumLinealCoeficient) / 100;
      const firstYear = 12 - this.monthDateStartWorking;
      const restMonths = (12 * this.investment.maximumPeriod) - firstYear;
      this.cuota = Math.round(percent / restMonths);
      this.ready = true;
    })
  }

}
